import './KwelloModal.scss';
import { Dialog } from '@progress/kendo-react-dialogs';
import { FlyoutHeader } from '../flyouts/components/FlyoutHeader';
import { KWELLO_ICON } from '../icon/KwelloSvgIcon';
import { useDispatch, useSelector } from 'react-redux';
import { hideModal, selectModalId } from 'common/store/slices/modal.slice';

interface KwelloModalProps {
  id: string;
  icon?: KWELLO_ICON;
  title?: string;
  subTitle?: string;
  children: React.ReactNode;
  width?: string;
  contentPadding?: string;
  headerActions?: React.ReactNode[];
  onClose?: () => void;
}

function KwelloModal({
  id,
  icon,
  title,
  subTitle,
  children,
  width,
  contentPadding,
  headerActions,
  onClose,
}: KwelloModalProps) {
  const dispatch = useDispatch();
  const modalId = useSelector(selectModalId);

  const closeModal = () => {
    dispatch(hideModal());
    onClose?.();
  };

  if (modalId !== id) {
    return null;
  }

  return (
    <Dialog className="kwello-modal" width={width}>
      {title && (
        <FlyoutHeader
          title={title}
          subTitle={subTitle}
          onCloseClick={closeModal}
          icon={icon}
          actions={headerActions}
        />
      )}

      <div className="kwello-modal-content" style={{ padding: contentPadding }}>
        {children}
      </div>
    </Dialog>
  );
}

export default KwelloModal;
